import SyncIcon from "@mui/icons-material/Sync";
import styled from "@emotion/styled";

const ConnectedCarrierIcon = styled(SyncIcon)(({ theme }) => ({
  fontSize: "1.5rem",
  color: theme.palette.brandSupporting.main as string,
}));

export default ConnectedCarrierIcon;
